import { render, staticRenderFns } from "./ToggleProfileFields.vue?vue&type=template&id=45484b5e&"
import script from "./ToggleProfileFields.vue?vue&type=script&lang=js&"
export * from "./ToggleProfileFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports